module.exports = __webpack_public_path__ + "static/service-boundary-2-d947b49603527c2343769531adc123a6.png";